/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HandleUndoEventRuleActionData } from './HandleUndoEventRuleActionData';
export type HandleUndoEventRuleActionPayload = {
    payload: HandleUndoEventRuleActionData;
    action: HandleUndoEventRuleActionPayload.action;
};
export namespace HandleUndoEventRuleActionPayload {
    export enum action {
        MOVE_RULE = 'move-rule',
        MOVE_OCCURRENCE = 'move-occurrence',
        SKIP_OCCURRENCE = 'skip-occurrence',
        UNDO = 'undo',
    }
}

